import { Route, Routes } from "react-router-dom";

import { InvoiceTemplateLink } from "../../pages";

export const InvoiceTemplateLinkLayout = () => {
  return (
    <Routes>
      <Route path="/" element={<InvoiceTemplateLink/>} />
    </Routes>
  );
};
